import { useNavigate, } from "react-router-dom";

import { IUpcomingPayment, } from "../../../../../api";
import { RoutesMap, } from "../../../../../routes.tsx";
import { UpcomingPaymentCard, } from "../UpcomingPaymentCard.tsx";
import { UpcomingPaymentCardEmpty, } from "../UpcomingPaymentCardEmpty.tsx";

interface IUpcomingPaymentBlockView {
  isLoading: boolean;
  isSuccess: boolean;
  data: IUpcomingPayment[];
}

export function UpcomingPaymentBlockView({ isLoading, isSuccess, data, }: IUpcomingPaymentBlockView,) {
  const navigate = useNavigate();

  return (
    <>
      {!(isLoading) && data.length === 0 && (
        <UpcomingPaymentCardEmpty />
      )}

      {(isSuccess) && data.length > 0 && (
        <UpcomingPaymentCard
          amount={data[0].amount}
          date={data[0].date}
          onPayClick={() => {
            navigate(RoutesMap.payments.index,);
          }}
        />
      )}

      {(isLoading) && (
        <>
          <UpcomingPaymentCard isLoading />
        </>
      )}
    </>
  );
}
